import { CwtApiSchema, CwtProp, CwtSchema } from "@cawita/core-front/api";

@CwtSchema()
export class QuestionAnswer extends CwtApiSchema {
    @CwtProp() questionOrder: number;
    @CwtProp() answerId: string;
    @CwtProp() value: number;
}